"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./browser"), exports);



//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/dist/compatibility/index.js
// module id = 327
// module chunks = 168707334958949